import * as HttpService from './HttpService'

let namespace = 'calculations/time-usage'

let all = (params, cb, errorCb) => {
    HttpService.get(namespace, params, cb, errorCb)
}

let skills = (params, cb, errorCb) => {
    HttpService.get(namespace + '/skills', params, cb, errorCb)
}

let employees = (params, cb, errorCb) => {
    HttpService.get('time-usage/employees', params, cb, errorCb)
}

export {
    all,
    skills,
    employees
}



// WEBPACK FOOTER //
// ./src/services/timeUsageService.js